import "./ConfirmMessage.css";
import ReactDOM from "react-dom";
import { useEffect, useState } from "react";

// Simple loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

const ConfirmMessage = ({
  showModal,
  actionType,
  handleConfirmAction,
  handleCancelAction,
  selectedPhotos,
  AllPhotos,
}) => {
  const [loading, setLoading] = useState(true);
  const [photosToDisplay, setPhotosToDisplay] = useState([]);
  
  useEffect(() => {
    if (showModal) {
      // Simulating an async operation like fetching data
      
      setLoading(true); 
      const timeout = setTimeout(() => {
        const filteredPhotos = AllPhotos.filter((photo) =>
          selectedPhotos.includes(photo.id)
        );
        setPhotosToDisplay(filteredPhotos);
        setLoading(false); // Set loading to false once photos are ready
      }, 1000); // You can adjust the timeout as needed for your loading time

      return () => clearTimeout(timeout); // Cleanup on unmount
    }
  }, [showModal, selectedPhotos, AllPhotos]);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      handleCancelAction();
    }
  };
  const handleCancel = () => {
    setPhotosToDisplay([]); // Reset photosToDisplay to an empty array
    handleCancelAction(); // Call the passed cancel action
  };
  return ReactDOM.createPortal(
    <>
      {showModal && (
        <div className="modal-overlay" onClick={handleOverlayClick}>
          <div className="modal">
            <h2>Are you sure you want to {actionType} the selected photos?</h2>
            <div className="selected-images">
              {loading ? (
                <LoadingSpinner /> // Show loading spinner while loading
              ) : (
                photosToDisplay.map((photo) => (
                  <img
                    key={photo.id}
                    src={photo.url.url}
                    alt={photo.description || "Photo"}
                    className="thumbnail"
                    onError={(e) => {
                      e.target.src = "path/to/placeholder-image.jpg"; // Fallback image
                    }}
                  />
                ))
              )}
            </div>
            <div className="modal-buttons">
              <button className="modal-confirm" onClick={handleConfirmAction}>
                Yes
              </button>
              <button className="modal-cancel" onClick={handleCancel}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};

export default ConfirmMessage;
